<script setup lang="ts">
import type { IRateResponse } from '~/components/widget/rates'
import { BankRatesChart } from '~/components/ui/bank-rates-chart'

interface Props {
  title: string
  id: number
  organizationType?: string
}

const props = defineProps<Props>()

const selectedCurrency = ref('usd')
const isCashless = ref(false)

const { data: rates, pending } = await useFetch<IRateResponse>(`/api/rates/bank-history-cached`, {
  params: computed(() => ({
    currency: selectedCurrency.value,
    organization_id: props.id,
    type: isCashless.value ? 'cashless' : 'regular',
    ...(props.organizationType ? { organization_type: props.organizationType } : {})
  })),
  key: computed(() => `rates-history-${selectedCurrency.value}-${props.id}-${isCashless.value}-${props.organizationType ?? ''}`),
  server: false,
  watch: [selectedCurrency, isCashless]
})

const handleCurrencyUpdate = (currency: string) => {
  selectedCurrency.value = currency
}

const handleCashlessUpdate = (cashless: boolean) => {
  isCashless.value = cashless
}
</script>

<template>
  <BankRatesChart
    :title="props.title"
    :data="rates"
    :loading="pending"
    @update:currency="handleCurrencyUpdate"
    @update:cashless="handleCashlessUpdate"
  />
</template>
